import { render, staticRenderFns } from "./orderWxshenpiKill.vue?vue&type=template&id=6e19784a&scoped=true"
import script from "./orderWxshenpiKill.vue?vue&type=script&lang=js"
export * from "./orderWxshenpiKill.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpiKill.vue?vue&type=style&index=0&id=6e19784a&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpiKill.vue?vue&type=style&index=1&id=6e19784a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19784a",
  null
  
)

export default component.exports